import { BaseError } from './base';

export class NoPasskeyCredentialsFoundError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'no_passkey_credentials_found_error',
      docsUrl: null,
      name: 'NoPasskeyCredentialsFoundError',
      shortMessage: 'No passkey credentials found',
    });
  }
}
